import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Modal, Row, Button } from 'react-bootstrap';
import '../../assets/Styles/DispatchCSS/DispatchCSS.css';
import MultiSelectDropdown from "../Controls/multiselectdropdown";
import Cluster from "./ClusteringActions/Cluster";
import UnCluster from "./ClusteringActions/UnCluster";
import APICom from '../../utils/helpers/APICom';
let clusterComboData = [];
const BuildCluster = (props) => {
    const [clusterFilterMultiSelect, setclusterFilterMultiSelect] = useState({ options: [], DropdownMode: 'rS', styles: { width: "98%", marginLeft: "0px" }, selectedValues: [] });
    const [isCreateNew, setIsCreateNew] = useState(true);
    const [showClusterActionCreate, setClusterActionCreate] = useState(false);
    const [showUnClusterActionCreate, setUnClusterActionCreate] = useState(false);
    const [disableUnClusterButton, setDisableUnClusterButton] = useState(true);
    const [disableAllButtons, setdisableAllButtons] = useState(false);
    const [selectedManifest, setselectedManifest] = useState("");
    const [NoOfGroup, setNoOfGroup] = useState(-1);
    const addSingleTripToRoute = useRef(props.addtoRoute);
    const routeRef = useRef(props.addTripRoute);
    const [SelectedRouteSettingID, setSelectedRouteSettingID] = useState(-1);
    useEffect(() => {
        try{
            let groupOptions = [];
            const set = new Set();
            GetClusterDropDownData(props.selectedDate, props.selectedAffiliates);
            const distinctGroup = [...new Set(props.GridRowData
                .map(data => data.Group)
                .filter(Group => Group)
              )];
            setNoOfGroup(distinctGroup.length);
            if(addSingleTripToRoute.current)
            {
                setDisableUnClusterButton(true);
                setIsCreateNew(false);
            }
            else
            {
                if(props.GridRowData !== undefined) {
                    props.GridRowData.forEach((data) => {
                        if (data.Route !== "") {
                            setDisableUnClusterButton(false);
                        }
                    });
                }
            }

            if(props.triggerUnRoute)
            {
                handleUnClusterActionCreate();
                props.setTriggerUnRoute(false);
            }
        }
        catch(err){console.log(err);}
        
    }, [props.triggerUnRoute]);

    useEffect(() => {
        routeRef.current = props.addTripRoute;
    }, [props.addTripRoute]);

    const handleCloseClusteringDialog = () => {
        if (props.showClusteringDialog) {
            props.setAddtoRoute(false);
            props.setGridRefreshPaused(false);
            props.setShowClusterDialog(false);
        }
    }

    const handleCheckboxChange = (event) => {
        if (event.target.value === "AddNew") {
            setIsCreateNew(true);
            setselectedManifest("");
        }
        else {
            setIsCreateNew(false);
        }
    };

    const handleClusterActionCreate = () => {
        setClusterActionCreate(true);
    }

    const handleUnClusterActionCreate = () => {
        setUnClusterActionCreate(true);
    }

    const GetClusterDropDownData = async (date, aff) => {
        try{
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Clustering/GetClusterSummaryList?selected_date=" + date + "&affiliate_ids=" + aff, "get", { "Content-Type": "application/json" }, null, null);
            clusterComboData = response.data;
    
            let groupOptions = [];
            const set = new Set();
            if (clusterComboData != undefined && clusterComboData != "") {
                clusterComboData?.forEach((data) => {
                    if (data.ManifestNumber && !set.has(data.ManifestNumber)) {
                        set.add(data.ManifestNumber);
                        groupOptions.push({ "label": data.VirtualRoute, "value": data.ManifestNumber });
                    }
                });
            }
    
            if (groupOptions.length > 0) {
                setclusterFilterMultiSelect({ ...clusterFilterMultiSelect, options: groupOptions, selectedValues: groupOptions[0] });
            }
            if(addSingleTripToRoute.current && props.GridRowData.length === 1)
            {
                ClusterSelectCallback(routeRef.current);
            }
            else if(addSingleTripToRoute.current && props.GridRowData.length > 1)
            {
                ClusterSelectCallback(routeRef.current);
            }
        }
        catch(err){console.log(err);}
    }

    const ClusterSelectCallback = (_val) => {
        setselectedManifest(_val);
        if (_val !== "") {

            const selectedCluster = clusterComboData.find(data => data.ManifestNumber === _val);

            // Retrieve SettingID from the found object
            const SettingID = selectedCluster ? selectedCluster.iSettingID : null;

            setSelectedRouteSettingID(SettingID)
            setclusterFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: GetClusterSelectObjectBy(_val) } });
        }
    }

    const GetClusterSelectObjectBy = (_vVal) => {
        let groupOptions = [];
        for (let ii = 0; ii < clusterComboData.length; ii++) {
            if (clusterComboData[ii].ManifestNumber === _vVal) {
                groupOptions.push({ "label": clusterComboData[ii].VirtualRoute, "value": clusterComboData[ii].ManifestNumber });
                break;
            }
        }
        return groupOptions;
    }

    return (
        <>
            <Modal show={props.showClusteringDialog ? 1 : 0} centered animation={true} keyboard={true} onHide={handleCloseClusteringDialog} size="lg"
                aria-labelledby="contained-modal-title-vcenter" backdrop="static">
                <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
                    <Modal.Title className='dispatch_action_dialog_title_color user-select-none' id="contained-modal-title-vcenter">
                        Cluster Actions
                    </Modal.Title>
                </Modal.Header>
                {props.GridRowData.length > 0 ? 
                    <>
                        <Modal.Body className="grid-example user-select-none">
                            
                            <Container>
                                <Row>
                                    <Col md={3} className="w-100">
                                        <span>FOR TRIP : <b className="mx-2">{props.GridRowData.length > 1 ? props.GridRowData.length + " trips selected" : props.GridRowData[0]["ConfirmationNo"]}</b></span>
                                        <span className="firstRow"> Number of Groups : <b className="mx-2">{NoOfGroup}</b></span>
                                    </Col>
                                </Row>
                                <Row className="pt-2">
                                    <Col md={12} className="d-flex" >
                                        <label>Unique list of Mobility Attributes of Selected Trips: </label>
                                        <label id="lblMobilityAttributes" className="lblMobilityAttributes"></label>
                                    </Col>
                                </Row>
                                <Row className="pt-2">
                                    <Col md={6} className="d-flex" >
                                        <input type="radio" name="cluster_name" value="AddToExisting" onClick={handleCheckboxChange} readOnly checked={isCreateNew === false} />
                                        <label>&nbsp;&nbsp;Add to Existing Cluster</label>
                                    </Col>
                                    <Col md={6} className="d-flex" >
                                        <input type="radio" name="cluster_name" value="AddNew" onClick={handleCheckboxChange} readOnly checked={isCreateNew === true} />
                                        <label>&nbsp;&nbsp;Create New Cluster(s)</label>
                                    </Col>
                                </Row>
                                {isCreateNew === true ? null : (
                                    <>
                                        <Row className="pt-2">
                                            <Col md={4} className="d-flex">
                                                <label>Cluster #</label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={4} className="d-flex">
                                                <MultiSelectDropdown options={clusterFilterMultiSelect} showCheckbox={false} className="w-100" SelectionChangeCallback={ClusterSelectCallback} />
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </Container>
                        
                        
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="dark" value="Cluster" onClick={handleClusterActionCreate} disabled={disableAllButtons}>Cluster</Button>
                            <Button variant="dark" value="Un-Cluster" onClick={handleUnClusterActionCreate} disabled={disableUnClusterButton || disableAllButtons}>Un-Cluster</Button>
                            <Button variant="dark" onClick={handleCloseClusteringDialog}>Close</Button>
                        </Modal.Footer>
                    </>

                :   <>
                        <Modal.Body className="user-select-none fw-bold">{"Please select a trip first before clustering."}</Modal.Body>
                        <Modal.Footer>
                        
                            <Button variant="dark" onClick={handleCloseClusteringDialog}>OK</Button>
                        
                        </Modal.Footer>
                    </>
                }
                
            </Modal>
            {showClusterActionCreate ? <Cluster GridRefresh={props.GridRefresh} GridRowData={props.GridRowData} showClusterActionCreate={showClusterActionCreate} 
            setClsuterActionCreate={setClusterActionCreate} disbaleButton={setdisableAllButtons} manifestNumber={isCreateNew ? "" : selectedManifest} 
            setIsCreateNew= {isCreateNew} selectedDate={props.selectedDate} selectedAffiliates={props.selectedAffiliates} SelectedRouteSettingID = {SelectedRouteSettingID}/> : ""}
            {showUnClusterActionCreate ? <UnCluster GridRefresh={props.GridRefresh} GridRowData={props.GridRowData} showUnClusterActionCreate={showUnClusterActionCreate} setUnClsuterActionCreate={setUnClusterActionCreate} disbaleButton={setdisableAllButtons} selectedDate={props.selectedDate} selectedAffiliates={props.selectedAffiliates}/> : ""}

        </>
    );
}

export default BuildCluster;